<template>
  <div class="animated fadeIn">
    <b-card no-header>
      <b-form>
        <app-caja-origen
          label="Origen"
          :label-cols="labelCols"
          :nombre="cajaRegistroOrigenNombre"
          :valido="cajaRegistroOrigenValida"
          :lista="cajasRegistrosList"
          :msjInvalido="cajaRegistroOrigenInvalidaMsj"
          @validate="validate"
          @updated="cajaRegistroOrigenActualizada">
        </app-caja-origen>  

        <app-caja-destino
          label="Destino"
          :label-cols="labelCols"
          :nombre="cajaRegistroDestinoNombre"
          :valido="cajaRegistroDestinoValida"
          :lista="cajasRegistrosList"
          :msjInvalido="cajaRegistroDestinoInvalidaMsj"
          @validate="validate"
          @updated="cajaRegistroDestinoActualizada">
        </app-caja-destino>  

        <b-form-group
          label="Pesos"
          label-for="pesos"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="pesos"
            v-model.trim="$v.pesos.$model" 
            :state="pesosValidos"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="pesosFeedback">
            {{ pesosInvalidosMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </b-form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>
    
    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import { decimal, minValue } from 'vuelidate/lib/validators';
import CajaOrigen from '../shared/abmSelect.vue';
import CajaDestino from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cajatransferencia/getField',
  mutationType: 'cajatransferencia/updateField',
});

export default {
  name: 'ABM',
  components: {
    appCajaOrigen: CajaOrigen,
    appCajaDestino: CajaDestino,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      cajaRegistroOrigenValida: null,
      cajaRegistroOrigenInvalidaMsj: '',
      cajaRegistroDestinoValida: null,
      cajaRegistroDestinoInvalidaMsj: '',
      pesosValidos: null,
      pesosInvalidosMsj: '',

      cajasRegistros: [],
      cajasRegistrosList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'cajaRegistroOrigen',
      'cajaRegistroOrigenNombre',
      'cajaRegistroDestino',
      'cajaRegistroDestinoNombre',
      'pesos',
    ]),
  },  
  created() {
    this.getDatosAdicionales();

    this.showSpinner();
    this.$store.dispatch('cajatransferencia/inicializar')
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },
  methods: {
    getDatosAdicionales() {
      let vm = this;
      vm.$store.dispatch('cajasregistros/getCajasRegistrosSelect')
        .then(() => {
          vm.cajasRegistros = this.$store.getters['cajasregistros/cajasRegistrosSelect'];
          vm.cajasRegistrosList = this.$store.getters['cajasregistros/cajasRegistrosSelectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cajas disponibles.'))
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      /*
      if (campo == 'cajaOrigenNombre' || validarTodos) {
        if (this.$v.cajaOrigen.$error) {
          this.cajaOrigenValida = false;
          if (!this.$v.ingresoEgresoTipoNombre.required) {
            this.ingresoEgresoTipoInvalidoMsj= 'Debe seleccionar el tipo de movimiento.';
          } 
        } else {
          this.ingresoEgresoTipoValido = null;
          this.ingresoEgresoTipoInvalidoMsj = '';
        }
      }
      */

      if (campo == 'pesos' || validarTodos) {
        if (this.$v.pesos.$error) {
          this.pesosValidos = false;
          if (!this.$v.pesos.decimal) {
            this.pesosInvalidosMsj = 'El importe debe ser un valor numérico';
          } else if (!this.$v.pesos.minValue) {
            this.pesosInvalidosMsj = 'Ingrese el importe a transferir';
          } 
        } else {
          this.pesosValidos = null;
          this.pesosInvalidosMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let cajaRegistroOrigen;
      if (this.cajaRegistroOrigenNombre) {
        cajaRegistroOrigen = this.getSelected(this.cajasRegistros, this.cajaRegistroOrigenNombre);
      }
      this.$store.dispatch('cajatransferencia/setCajaRegistroOrigen', cajaRegistroOrigen);

      let cajaRegistroDestino;
      if (this.cajaRegistroDestinoNombre) {
        cajaRegistroDestino = this.getSelected(this.cajasRegistros, this.cajaRegistroDestinoNombre);
      }
      this.$store.dispatch('cajatransferencia/setCajaRegistroDestino', cajaRegistroDestino);

      this.$v.$touch();

      let save = true;

      let errorCajaOrigen = true;
      if (this.cajaRegistroOrigen) {
        if (this.cajaRegistroOrigen.id){
          if (this.cajaRegistroOrigen.id != 0){
            errorCajaOrigen = false;
          }
        }
      } 
      if (errorCajaOrigen) {
        save = false;
        this.cajaRegistroOrigenValida = false;
        this.cajaRegistroOrigenInvalidaMsj = 'Debe seleccionar la caja origen.';
      }

      let errorCajaDestino = true;
      if (this.cajaRegistroDestino) {
        if (this.cajaRegistroDestino.id){
          if (this.cajaRegistroDestino.id != 0){
            errorCajaDestino = false;
          }
        }
      } 
      if (errorCajaDestino) {
        save = false;
        this.cajaRegistroDestinoValida = false;
        this.cajaRegistroDestinoInvalidaMsj = 'Debe seleccionar la caja de destino.'
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.showSpinner();
          this.$store.dispatch('cajatransferencia/save', this.id)
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.close.bind(this, true), this.close.bind(this, true), 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    close(transferenciaRegistrada) {
      this.$emit('close', transferenciaRegistrada);
    },
    cajaRegistroOrigenActualizada(nombre) {
      this.cajaRegistroOrigenNombre = nombre;
      
      if ( this.cajaRegistroOrigenNombre ) {
        this.cajaRegistroOrigenValida = null;
        this.cajaRegistroOrigenInvalidaMsj = '';
      }
    },
    cajaRegistroDestinoActualizada(nombre) {
      this.cajaRegistroDestinoNombre = nombre;
      
      if ( this.cajaRegistroDestinoNombre ) {
        this.cajaRegistroDestinoValida = null;
        this.cajaRegistroDestinoInvalidaMsj = '';
      }
    },
  },
  validations: {
    pesos: {
      decimal,
      minValue: minValue(1)
    },
  },  
}
</script>

<style>
</style>
